module.exports = __webpack_public_path__ + "@/assets/img/23.7fe26666.jpg";